/* screens/crm/MoveReasonModal.jsx — обязательная причина при перемещении лида.
   Открывается и при drag-drop (целевой этап задан, presetToStage), и из карточки
   лида (пользователь выбирает этап из списка). Без непустой причины кнопка не
   срабатывает; бэк дублирует проверку (400 reason_required). */
import React from 'react';
import { Button } from '../../components/ui/Button.jsx';
import { Field, Textarea } from '../../components/ui/Field.jsx';
import { Select } from '../../components/ui/Select.jsx';
import { Modal } from '../../components/ui/Modal.jsx';

const { useState, useEffect } = React;

function MoveReasonModal({ open, lead, fromStage, presetToStage, stages = [], presets = [], batchCount = 0, onCancel, onConfirm }) {
  const [reason, setReason] = useState('');
  const [targetId, setTargetId] = useState('');
  const [err, setErr] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setReason('');
      setErr('');
      setSaving(false);
      setTargetId(presetToStage ? String(presetToStage.id) : '');
    }
  }, [open, lead?.id, presetToStage?.id]);

  const options = stages
    .filter((s) => !fromStage || s.id !== fromStage.id)
    .map((s) => ({ value: String(s.id), label: s.name }));

  const submit = async () => {
    const v = reason.trim();
    let to;
    if (presetToStage) {
      // Этап мог исчезнуть, пока модалка открыта (переименование/архивация
      // воронки на лету через конструктор) — не отправляем устаревший id.
      if (!stages.some((s) => s.id === presetToStage.id)) {
        setErr('Целевой этап больше не доступен.'); return;
      }
      to = presetToStage.id;
    } else {
      if (targetId === '') { setErr('Выберите этап.'); return; }
      to = Number(targetId);
      if (Number.isNaN(to)) { setErr('Выберите этап.'); return; }
    }
    if (!v) { setErr('Укажите причину перемещения.'); return; }
    setSaving(true);
    try {
      await onConfirm(to, v);
    } catch (e) {
      setErr(e?.detail || e?.message || 'Не удалось переместить лид.');
      setSaving(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={saving ? undefined : onCancel}
      title="Причина перемещения"
      size="sm"
      autoFocusSelector="textarea"
      footer={<>
        <Button variant="ghost" onClick={onCancel} disabled={saving}>Отмена</Button>
        <Button variant="primary" onClick={submit} loading={saving}>Переместить</Button>
      </>}
    >
      <div className="stack stack-12">
        {batchCount > 0 && (
          <p className="text-dim">Будет перемещено лидов: <strong>{batchCount}</strong>. Причина — общая для всех.</p>
        )}
        {presetToStage ? (
          <p className="text-dim">
            <strong>{lead?.client}</strong>: {fromStage?.name || '—'} → <strong>{presetToStage.name}</strong>
          </p>
        ) : (
          <Field label="Этап" required>
            <Select value={targetId} onChange={(v) => { setTargetId(v); setErr(''); }}
              options={options} placeholder="Куда переместить" searchable={options.length > 6} />
          </Field>
        )}
        <Field label="Почему лид перемещается?" error={err} required>
          <Textarea value={reason} onChange={(e) => { setReason(e.target.value); setErr(''); }}
            minRows={3} maxRows={8} invalid={!!err}
            placeholder="Например: дозвонились, клиент согласовал смету…" />
        </Field>
        {presets.length > 0 && (
          <div className="crm-reason-chips">
            {presets.map((p) => (
              <button key={p} type="button" className="crm-chip"
                onClick={() => { setReason(p); setErr(''); }}>{p}</button>
            ))}
          </div>
        )}
        <p className="t-caption text-mute">Причина сохранится в истории лида без возможности удаления.</p>
      </div>
    </Modal>
  );
}

export { MoveReasonModal };
